import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { getUserAction } from '../../../browser/services/user';
import { TReduxActions } from '../../types/redux';
import { TThunkAction } from '../../types/redux/thunk';
import { withScrollRestoration } from '../../utils/dom/withScrollRestoration';
import { getIsAuthenticated } from '../../selectors/newbuilding';
import type { EAlertType } from '../../repositories/header-frontend/microfrontend-api/types';

export { EAlertType } from '../../repositories/header-frontend/microfrontend-api/types';

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): TThunkAction | TReduxActions;
  onCloseNoAuth?(): TThunkAction | TReduxActions;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return async (dispatch, getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      if (getIsAuthenticated(getState())) {
        /* istanbul ignore else */
        if (parameters?.onSuccess) {
          dispatch(parameters.onSuccess());
        }

        return;
      }

      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          // После авторизации высота страницы меняется, а величина скролла сохраняется,
          // поэтому восстанавливаем визуальное положение элементов.
          await withScrollRestoration(async () => dispatch(getUserAction()));

          /* istanbul ignore else */
          if (parameters?.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          /* istanbul ignore else */
          if (parameters?.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      /* istanbul ignore else */
      if (context.microfrontendsAPI) {
        await context.microfrontendsAPI.header.openAuthModal({
          autoRefresh: false,
        });
      }
    }
  };
}
